import styled from '@emotion/styled'

export const SAddLegacyContactModal = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  & > *:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`

export const SImage = styled.img`
  height: auto;
  max-width: 250px;
  align-self: center;
`
